import { useState } from "react"
import { InputBorderless } from "../inputs/InputBorderless"
import { Tag } from "../tag/Tag"
import { CloseIcon } from "../icons/close/CloseIcon"
import { TOnChangeInput } from "types/default.type"
import style from "./NumbersTextarea.module.scss"

const { modelNumbersTexarea, tags, text } = style

type Props = {
	numbers: string[]
	setNumbers: (numbers: string[]) => void
	helperText?: string
	onValidationChange?: (isValid: boolean) => void
}

export const NumbersTextarea = ({ numbers, setNumbers, helperText, onValidationChange }: Props) => {
	const [inputValue, setInputValue] = useState<string | undefined>()

	const onCloseHandle = (removedTag: string) => {
		const updatedNumbers = numbers?.filter((tag) => tag !== removedTag)
		setNumbers(updatedNumbers)
	}

	const inputChangeHandle = (e: TOnChangeInput) => {
		const value = e.target.value
		setInputValue(value)
		// Notify parent that there's unconfirmed input
		onValidationChange?.(value.trim() === "")
	}

	const onConfirmHandle = () => {
		if (inputValue && !numbers?.includes(inputValue)) {
			setNumbers([...numbers, inputValue])
		}
		setInputValue("")
		// Notify parent that input is now confirmed (valid)
		onValidationChange?.(true)
	}

	return (
		<>
			<div className={modelNumbersTexarea}>
				<div className={tags}>
					{numbers?.map((modelNumber) => (
						<Tag key={modelNumber} closeIcon={<CloseIcon />} onClick={() => onCloseHandle(modelNumber)}>
							{modelNumber}
						</Tag>
					))}
				</div>
				<InputBorderless inputChangeHandle={inputChangeHandle} onConfirmHandle={onConfirmHandle} value={inputValue} />
			</div>
			<p className={text}>{helperText}</p>
		</>
	)
}
